import * as account from './account';
import * as auth from './auth';
import * as campaignDefaults from './campaign-defaults';
import * as campaigns from './campaigns';
import * as leads from './leads';
import * as listings from './listings';
import * as personalCampaigns from './personal-campaigns';
import * as personalLeads from './personal-leads';
import * as user from './user';

export const API_PATHS = {
  account,
  auth,
  campaignDefaults,
  campaigns,
  leads,
  listings,
  personalCampaigns,
  personalLeads,
  user,
};
